import React from "react";
import { connect } from "react-redux";
import ContentEditable from "react-contenteditable";
import Options from "./Options/Options";
import { Row, Col, Input, FormFeedback } from "reactstrap";
import { labelAlignment } from "../../../helpers/labelAlignment";
import { inputValidator } from "../../../../helpers/inputVaildator";
import IsRequiredSymbol from "../../../../components/UI/Form/IsRequiredSymbol";
import { conditionActions } from "../../../../store/actions/cms/condition.action";
import { deepClone } from "../../../../helpers/objectHelper";
import { formActions } from "../../../../store/actions/cms/form/form.action";
import { attendeeActions } from "../../../../store/actions/attendee/attendee.action";

class Question extends React.Component {
  componentDidMount() {
    if (this.props.updateValidator && typeof this.props.updateValidator === 'function') {
      this.props.updateValidator(this.updateValidator);
    }
  }
  componentWillUnmount() {
    if (
      this.props.updateValidator &&
      typeof this.props.updateValidator === "function"
    ) {
      this.props.updateValidator(this.updateValidator, true);
    }
  }
  updateValidator = () => {
    if (
      this.props.getValidator &&
      typeof this.props.getValidator === "function"
    ) {
      this.props.getValidator(() => this.validateField());
      this.props.getValidator(() => this.validateOptions());
    }
  }
  isChangeLocked = () => {
    const { element, attendee } = this.props;
    if (attendee && attendee.orders && attendee.orders.length > 0 && this.props.attendee.orders[0].orderId !== undefined && element.data.changeLock) {
      return true;
    }
    return false;
  }
  validateField = () => {
    const input = this.getFieldValue();
    const { element, dispatch, cms } = this.props;
    let isValid = true;
    let errorMessage = "";

    if (element.data.readOnly || element.data.hidden) {
      isValid = false;
      return { isValid };
    }
    if (element.data.required && input.toString().replace(/\s/g, "").length) {
      isValid = false;
    }
    if (
      element.data.minCharacters > 0 &&
      input.length < element.data.minCharacters
    ) {
      isValid = false;
    }
    if (element.data.validation.type !== "none") {
      isValid = inputValidator(input, element.data.validation.type);
    }
    if (element.isValid !== isValid) {
      let newElement = deepClone(element);
      newElement.isValid = isValid;
      dispatch(formActions.updateFormElement(newElement));
    }
    if (!cms.editMode) {
      dispatch(conditionActions.triggerCheck(element.formElementId));
    }
    return isValid;
  };
  validateOptions = () => {
    const { element, dispatch, cms } = this.props;
    let isValid = true;

    if (element.data.readOnly || element.data.hidden) {
      isValid = true;
      return isValid;
    }

    let min = element.props.requiredMin;
    let max = element.props.requiredMax;

    const checkedCount = this.getCheckedCount();

    if ((element.data.required && checkedCount === 0)
      || (min > 0 && checkedCount < min)
      || (max > 0 && checkedCount > max)) {
      isValid = false;
    }

    if (element.isValid !== isValid) {
      let newElement = deepClone(element);
      newElement.isValid = isValid;
      dispatch(formActions.updateFormElement(newElement));
    }
    if (!cms.editMode) {
      dispatch(conditionActions.triggerCheck(element.formElementId));
    }
    return isValid;
  };
  getCheckedCount = () => {
    const { element, attendee } = this.props;
    if (attendee && attendee.orders && attendee.orders.length > 0) {
      let order = attendee.orders[attendee.activePersonNo];
      if (order.answer) {
        let answer = order.answer.find(a => a.questionId == element.id);
        if (answer && answer.answerRow && answer.answerRow.length > 0) {
          let rows = answer.answerRow.filter(
            ar => ar.questionOptionId != 0 && !ar.deleted
          );
          return rows.length;
        }
      }
    }
    return 0;
  };
  handleUpdate = element => {
    const { dispatch, cms } = this.props;
    element.forceValidationMessage = false;
    dispatch(formActions.updateFormElement(element));
    if (!cms.editMode) {
      dispatch(conditionActions.triggerCheck(element.formElementId));
    }
  };
  handleChange = (e, path) => {
    const { form } = this.props;
    const names = path.split(".");
    const element = deepClone(this.props.element);

    if (names[1] === "labels") {
      element.props.labels.map(l => {
        if (l.languageCode === form.languageCode) {
          l.text = e.target.value;
        }
      });
    } else if (names[1] === "subInputs") {
      element.props.subInputs.map(l => {
        if (l.languageCode === form.languageCode) {
          l.text = e.target.value;
        }
      });
    } else if (names[1] === "subLabels") {
      element.props.subLabels.map(l => {
        if (l.languageCode === form.languageCode) {
          l.text = e.target.value;
        }
      });
    } else {
      element[names[0]][names[1]] = e.target.value;
    }
    this.handleUpdate(element);
  };

  handleValueChange = value => {
    const { element, attendee, dispatch } = this.props;

    if (attendee && attendee.orders && attendee.orders.length > 0) {
      let order = deepClone(attendee.orders[attendee.activePersonNo]);

      if (!order.answer) order.answer = [];
      let answer = order.answer.find(a => a.questionId == element.id);
      if (!answer) {
        answer = {
          answerId: -1,
          interactionKey: null,
          orderId: -1,
          questionId: element.id,
          answerRow: []
        };
        order.answer.push(answer);
      }
      if (!answer.answerRow) answer.answerRow = [];
      let row = answer.answerRow.find(
        ar => !ar.questionOptionId || ar.questionOptionId == 0
      );
      if (row) {
        row.text = value;
      } else {
        answer.answerRow.push({
          answerId: -1,
          answerRowId: -1,
          questionOptionId: 0,
          text: value,
          deleted: false
        });
      }
      console.log("question", order.orderRow, order, attendee.activePersonNo);
      dispatch(attendeeActions.updateOrder(order, attendee.activePersonNo));
    }
    clearTimeout(this.validateTimeout);
    this.validateTimeout = setTimeout(this.validateField, 200);
  };
  getFieldValue = () => {
    const { element, attendee } = this.props;
    if (attendee && attendee.orders && attendee.orders.length > 0) {
      let order = attendee.orders[attendee.activePersonNo];
      if (order.answer) {
        let answer = order.answer.find(a => a.questionId == element.id);
        if (answer && answer.answerRow && answer.answerRow.length > 0) {
          let row = answer.answerRow.find(ar => ar.questionOptionId == 0);
          if (row && !row.deleted) {
            return row.text;
          }
        }
      }
    }
    return "";
  };
  handleBlur = () => { };

  getQuestionLabels = () => {
    const element = deepClone(this.props.element);
    const { form } = this.props;
    const questionLabel =
      element &&
      element.props.labels &&
      element.props.labels.find(l => {
        return l.languageCode === form.languageCode && l.text ? l : "";
      });
    const questionSubLabel =
      element &&
      element.props.subLabels &&
      element.props.subLabels.find(l => {
        return l.languageCode === form.languageCode && l.text ? l : "";
      });
    const questionSubInput =
      element &&
      element.props.subInputs &&
      element.props.subInputs.find(l => {
        return l && l.languageCode === form.languageCode && l.text ? l : "";
      });

    return { questionLabel, questionSubInput, questionSubLabel };
  };

  render() {
    const { element, form, cms } = this.props;
    const { template, previewDevice } = this.props.template;
    const {
      questionLabel,
      questionSubInput,
      questionSubLabel
    } = this.getQuestionLabels();

    if (element && element.data && element.data.hidden && !cms.editMode)
      return null;
    else
      return element ? (
        <div
          style={{
            padding:
              element.data.padding !== undefined && element.data.padding + "px",
            width: "100%"
          }}
        >
          {element.data.hidden && (
            <div className="hidden-element">
              <i className="fa fa-eye-slash hidden-element-icon" />
            </div>
          )}
          <Row
            style={{ display: cms.editMode && previewDevice === 'smartphone' ? 'block' : undefined, flexDirection: labelAlignment(element.data.labelAlign), margin: '0px' }}
            className="responsive-row"
          >
            <Col
              className="qs-label-col"
              style={{
                maxWidth: cms.editMode && previewDevice === 'smartphone' ? '100%' :
                  (element.data.labelAlign !== "center" &&
                    element.data.titleWidth !== undefined &&
                    element.data.titleWidth + "%"),
                wordBreak: element.data.labelAlign !== "center" && "break-word",
                padding: '0px'
              }}
            >
              <div style={{ display: "inline-flex", width: "100%" }}>
                <ContentEditable
                  style={
                    template && template.content
                      ? {
                        ...template.content.label,
                        marginRight: "10px",
                        wordBreak: "break-word"
                        /*   lineHeight: element.props.type === 'Text' ? '36px' : 'unset', */
                      }
                      : {
                        wordBreak: "break-word"
                      }
                  }
                  innerRef={this.contentEditable}
                  onBlur={this.handleOnBlur}
                  onChange={e => this.handleChange(e, "props.labels")}
                  tagName="label"
                  disabled={!cms.editMode}
                  html={
                    questionLabel && questionLabel !== undefined
                      ? questionLabel.text
                      : ""
                  }
                />
                <IsRequiredSymbol
                  condition={
                    element.props.requiredMin > 0 ||
                    element.data.required ||
                    element.data.minCharacters > 0
                  }
                />
              </div>
              {element.data.showSubLabel && (
                <ContentEditable
                  innerRef={this.contentEditable}
                  html={
                    questionSubLabel && questionSubLabel !== undefined
                      ? questionSubLabel.text
                      : ""
                  }
                  style={{
                    color:
                      template !== undefined && template.content.text.color,
                    fontFamily:
                      template !== undefined &&
                      template.content.text.fontFamily,
                    fontSize:
                      template !== undefined && template.content.text.fontSize,
                    backgroundColor:
                      this.props.selectedElement &&
                      this.props.selectedElement.contentId ===
                      element.contentId &&
                      "whitesmoke",

                    wordBreak: "break-word"
                  }}
                  disabled={!cms.editMode}
                  onChange={e => this.handleChange(e, "props.subLabels")}
                  tagName="p"
                />
              )}
            </Col>

            <Col
              className="responsive-input-slot"
              style={{
                maxWidth: cms.editMode && previewDevice === 'smartphone' ? '100%' : (
                  element.data.labelAlign !== "center" &&
                  element.data.inputWidth !== undefined &&
                  element.data.inputWidth + "%"),
                padding: '0px'
              }}
            >
              {element.props.type === "Text" ? (
                <React.Fragment>
                  <Input
                    className="responsive-input"
                    type="textarea"
                    value={this.getFieldValue()}
                    rows={element.data.textRows}
                    readOnly={element.data.readOnly || (!cms.editMode && this.isChangeLocked())}
                    required={element.data.required || false}
                    style={
                      template !== undefined && {
                        ...template.content.input,
                        resize: "none",
                        width: cms.editMode && previewDevice === 'smartphone' ? '100%' : (element.data.style.width.toString().includes('%') ? element.data.style.width : element.data.style.width + '%'),
                      }
                    }
                    maxLength={element.data.maxCharacters}
                    onChange={e => this.handleValueChange(e.target.value)}
                    valid={element.isValid === true}
                    invalid={element.isValid === false}
                  />
                  <FormFeedback valid={element.isValid == true}>
                    {element.isValid === false ? element.data.validation.message : null}
                  </FormFeedback>
                  {element.data.showSubInput && (
                    <ContentEditable
                      innerRef={this.contentEditable}
                      html={
                        questionSubInput && questionSubInput !== undefined
                          ? questionSubInput.text
                          : ""
                      }
                      style={{
                        color:
                          template !== undefined && template.content.text.color,
                        fontFamily:
                          template !== undefined &&
                          template.content.text.fontFamily,
                        fontSize:
                          template !== undefined &&
                          template.content.text.fontSize,
                        backgroundColor:
                          this.props.selectedElement &&
                          this.props.selectedElement.contentId ===
                          element.contentId &&
                          "whitesmoke",
                        wordBreak: "break-word"
                      }}
                      disabled={!cms.editMode}
                      onChange={e => this.handleChange(e, "props.subInputs")}
                      tagName="p"
                    />
                  )}
                </React.Fragment>
              ) : (
                  <div style={{ width: "100%" }}>
                    <Options
                      isChangeLocked={this.isChangeLocked}
                      options={element.props.options}
                      parent={element}
                      handleOptionsChange={this.handleOptionsChange}
                      validateOptions={this.validateOptions}
                    />
                    {element.data.showSubInput && (
                      <ContentEditable
                        innerRef={this.contentEditable}
                        html={
                          questionSubInput && questionSubInput !== undefined
                            ? questionSubInput.text
                            : ""
                        }
                        style={{
                          color:
                            template !== undefined && template.content.text.color,
                          fontFamily:
                            template !== undefined &&
                            template.content.text.fontFamily,
                          fontSize:
                            template !== undefined &&
                            template.content.text.fontSize,
                          backgroundColor:
                            this.props.selectedElement &&
                            this.props.selectedElement.contentId ===
                            element.contentId &&
                            "whitesmoke",
                          wordBreak: "break-word"
                        }}
                        disabled={!cms.editMode}
                        onChange={e => this.handleChange(e, "props.subInputs")}
                        tagName="p"
                      />
                    )}
                  </div>
                )}
            </Col>
          </Row>
        </div >
      ) : null;
  }
}

function mapStateToProps(state) {
  return {
    selectedElement: state.form.selectedElement,
    form: state.form,
    template: state.template,
    cms: state.cms,
    attendee: state.attendee,
  };
}

export default connect(mapStateToProps)(Question);
